export default "__VITE_ASSET__WDWsIcHw__"